import { useAuth } from '@/context/AuthContext';
import { api } from '@/lib/trpc/react';
import { skipToken } from '@tanstack/react-query';

type UseChatbotProps = {
  id?: string | null;
  enabled?: boolean;
};

const useChatbot = ({ id, enabled = true }: UseChatbotProps) => {
  const { isLoggedIn } = useAuth();

  const { data: chatbot, isLoading } = api.chatbot.byId.useQuery(
    id ?? skipToken,
    {
      // refetchInterval: 1000,
      enabled: !!id && isLoggedIn && enabled,
    },
  );

  return { chatbot, isLoading };
};

export default useChatbot;
